module.exports = __webpack_public_path__ + "static/hero-top-ec63ee5f911c1c1bde570c1823f310e8.png";